import chatModule from '../chatModule';

function linkCardController($scope, $log, eventStreamService, gameService, modalService, $window, $filter, pinGameService, gameLayout) {
    "ngInject";
    $scope.isLinkCardAvailableAndParsedByClientSide = function (pieceOfMessage) {
        return !pieceOfMessage.isLinkCard && pieceOfMessage.isCard;
    }

    $scope.sendEventStream = function (eventType, rootPlaceId) {
        var properties = {
            placeId: rootPlaceId,
            conversationId: $scope.dialogData.id
        };
        eventStreamService.sendEventWithTarget(eventType,
            $scope.chatLibrary.eventStreamParams.actions.click,
            properties);
    }

    $scope.sendLoadLinkCardEvent = function (rootPlaceId) {
        var properties = {
            placeId: rootPlaceId,
            conversationId: $scope.dialogData.id
        }
        eventStreamService.sendEventWithTarget($scope.chatLibrary.eventStreamParams.loadGameLinkCardInChat,
            $scope.chatLibrary.eventStreamParams.actions.render, properties);
    }


    $scope.sendGamePlayEnvent = function (rootPlaceId) {
        var context = $scope.chatLibrary.eventStreamParams.context;
        eventStreamService.sendGamePlayEvent(context.gamePlayFromLinkCard, rootPlaceId);
    }

    $scope.playGame = function (rootPlaceId, eventType, addition) {
        $scope.sendEventStream(eventType, rootPlaceId);
        $scope.sendGamePlayEnvent(rootPlaceId);
        if (addition && addition.privateServerLinkCode) {
            gameService.playPrivateServerGame(rootPlaceId, addition.privateServerLinkCode);
        } else {
            gameService.playRegularGame(rootPlaceId);
        }
    }

    $scope.buyAccess = function (placeId, layout) {
        var place = $scope.chatLibrary.placesLibrary[placeId];
        var gameIconUrl = place.gameIconUrl;
        var bodyText = $filter("formatString")(layout.buyAccess.bodyText(), { 'placeName': place.placeName, 'creatorName': place.creatorName, 'price': place.price });
        var options = {
            titleText: layout.buyAccess.title,
            bodyText: bodyText,
            imageUrl: gameIconUrl,
            actionButtonShow: true,
            actionButtonText: layout.buyAccess.yesButtonText,
            actionButtonClass: layout.buyAccess.yesButtonClass,
            neutralButtonText: layout.buyAccess.noButtonText,
            closeButtonShow: true
        }
        $scope.dialogLayout.playTogetherButton.isPlayButtonDisabled = true;
        var modal = modalService.open(options);
        modal.result.then(function () {
            //make purchase
            $log.debug("--- purchase ---");
            $scope.dialogLayout.playTogetherButton.isPlayButtonDisabled = false;
        }, function () {
            $log.debug("--- cancel ---");
            $scope.dialogLayout.playTogetherButton.isPlayButtonDisabled = false;
        });
    }

    $scope.goToPlaceDetails = function (rootPlaceId, eventType) {
        $scope.sendEventStream(eventType, rootPlaceId);
        $window.location.href = $scope.chatLibrary.placesLibrary[rootPlaceId].placeUrl;
    }

    $scope.play = function (placeId, eventType, addition) {
        var buttonType = $scope.chatLibrary.placesLibrary[placeId].buttonLayoutForLinkCard.type;
        switch (buttonType) {
            case gameLayout.playButtonTypes.play:
                $scope.playGame(placeId, eventType, addition);
                break;
            case gameLayout.playButtonTypes.buy:
                $scope.buyAccess(placeId, gameLayout);
                break;
            case gameLayout.playButtonTypes.details:
                $scope.goToPlaceDetails(placeId, eventType);
                break;
        }
    }
    $scope.pinGame = function (universeId, rootPlaceId) {
        universeId = parseInt(universeId);
        rootPlaceId = parseInt(rootPlaceId);
        var eventType = "";
        if (!$scope.dialogData.pinGame || $scope.dialogData.pinGame.rootPlaceId !== parseInt(rootPlaceId)) {
            eventType = $scope.chatLibrary.eventStreamParams.pinGameInLinkCard;
            pinGameService.sendPinGameEvent(eventType, rootPlaceId, $scope.dialogData);
            var parameters = {
                rootPlaceId: rootPlaceId,
                universeId: universeId,
                actorUsername: $scope.chatLibrary.username, //
                userId: $scope.chatLibrary.userId,
                placeName: $scope.chatLibrary.placesLibrary && $scope.chatLibrary.placesLibrary[rootPlaceId] ? $scope.chatLibrary.placesLibrary[rootPlaceId].placeName : "",
                encodedPlaceName: $scope.chatLibrary.placesLibrary && $scope.chatLibrary.placesLibrary[rootPlaceId] ? $scope.chatLibrary.placesLibrary[rootPlaceId].encodedPlaceName : ""
            };
            pinGameService.setPinGameData($scope.dialogData, parameters);
            pinGameService.pinGame($scope.dialogData, universeId);
            gameService.buildButtonLayoutPerConversation($scope.dialogData, $scope.chatLibrary.placesLibrary);
        }
    }
};

chatModule.controller("linkCardController", linkCardController);

export default linkCardController;